import React, { Component } from "react";
import { Card, Col, Row, Icon, Button, Tooltip } from "antd";
import { urlPath, imageUrlPath, devMode } from "./Settings";
import AssetUpload from "./AssetUpload";
import { getAuthHeader } from "../utils/security";

let assetsCards = [];

class Assets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assetsCards: [],
      editableView: this.props.editableView,
      matspecid: this.props.matspecid,
      value: null,
      translations: this.props.translations
    };
  }

  setNewAssets = (admaterialId, newAssetIds, matspecid) => {
    //console.log(newAssetIds)
    //console.log(matspecid)
    if (this.props.newAsset) this.props.newAsset(true);
    this.setState({ newAssetIds: newAssetIds });
  };

  deleteAsset = id => {
    let url = urlPath + "/api/assetdelete?asset=" + id;
    fetch(url, {
      method: "POST",
      credentials: "include",
      headers: getAuthHeader()
    })
      .then(response => {
        console.log("Asset deleted", response.text());
      })
      .catch(e => console.error("Cannot delete asset", e));
    document.getElementById("card." + id).classList.add("d-none");
  };
  uploadingAssets = () => {
    this.setState({ assetsCards: [] });
  };
  loadAssets = (matspecid, newAssetIds) => {
    if (this.isCancelled) return;
    const { editableView, translations } = this.state;
    this.setState({ assetsCards: [], preloadingMask: true });
    //console.log('Assets: loadAssets', editableView);
    if (matspecid) {
      fetch(
        urlPath +
        "/api/loadassets?matspec=" +
        matspecid +
        "&timezone=" +
        Intl.DateTimeFormat().resolvedOptions().timeZone,
        {
          credentials: "include",
          headers: getAuthHeader()
        }
      )
        .then(response => response.json())
        .then(data => {
          //console.log('Assets loaded: ', data);
          assetsCards = [];
          if ((editableView && this.props.canCreateAsset) || devMode)
            assetsCards.push(
              <Col
                xs={{ span: 24 }}
                lg={{ span: 6 }}
                md={{ span: 8 }}
                sm={{ span: 12 }}
                id="cardAssetUpload"
                className="asset-card"
              >
                <Card bordered={false}>
                  <AssetUpload
                    loadConfig={this.props.loadConfig}
                    uploadingAssets={this.uploadingAssets}
                    setNewAssets={this.setNewAssets}
                    loadAssets={() =>
                      this.loadAssets(
                        this.props.matspecid,
                        this.state.newAssetIds
                      )
                    }
                    materialSpecificationId={this.props.matspecid}
                    translations={this.props.translations}
                    unsubmittedChanges={this.props.unsubmittedChanges}
                  />
                </Card>
              </Col>
            );
          for (let i = 0; i < data.length; i++) {
            const currentAsset = data[i];
            const modificationdate = currentAsset.modificationdate;
            const modificationdateDay =
              modificationdate.charAt(0) + modificationdate.charAt(1);
            const modificationdateMonth =
              modificationdate.charAt(3) + modificationdate.charAt(4);
            const modificationdateYear =
              modificationdate.charAt(6) +
              modificationdate.charAt(7) +
              modificationdate.charAt(8) +
              modificationdate.charAt(9);
            const modificationdateTime =
              modificationdate.charAt(11) +
              modificationdate.charAt(12) +
              modificationdate.charAt(13) +
              modificationdate.charAt(14) +
              modificationdate.charAt(15);
            const modificationdateObject = new Date(
              modificationdateYear +
              "-" +
              modificationdateMonth +
              "-" +
              modificationdateDay +
              "T" +
              modificationdateTime
            );
            currentAsset.modificationdateToDate = Date.parse(
              modificationdateObject
            );
          }
          data.sort(function (a, b) {
            return b.modificationdateToDate - a.modificationdateToDate;
          });
          for (let i = 0; i < data.length; i++) {
            if (newAssetIds)
              for (let z = 0; z < newAssetIds.length; z++) {
                if (data[i].id === parseInt(newAssetIds[z], 10))
                  data[i].new = true;
              }
            let previewUrl = null;
            //console.log(data[i])
            if (data[i].processing) {
              this.loadAssets(matspecid, newAssetIds);
              break;
            }
            if (data[i].preview)
              previewUrl = imageUrlPath + data[i].preview.url;
            if (data[i].type !== "VISUAL" && data[i].type !== "LAYOUT_APP") {
              assetsCards.push(
                <Col
                  xs={{ span: 24 }}
                  lg={{ span: 6 }}
                  md={{ span: 8 }}
                  sm={{ span: 12 }}
                  id={"card." + data[i].id}
                  className="asset-card"
                >
                  <Card bordered={true}>
                    {data[i].new ? (
                      <div
                        data-translationkey="newAsset"
                        className="asset-new-ribbon"
                      >
                        {translations ? translations.newAsset : "New asset"}
                      </div>
                    ) : null}
                    <div
                      data-translationkey="visualAsset"
                      className="asset-visual-ribbon"
                    >
                      {translations ? translations.visualAsset : "Visual"}
                    </div>
                    <div
                      className="asset-cover"
                      style={{ background: "url(" + previewUrl + ")" }}
                    />
                    <ul className="asset-info-list">
                      <li>
                        <span
                          data-translationkey="name"
                          className="asset-card-prop"
                        >
                          {translations ? translations.name + ": " : "name: "}
                        </span>
                        <Tooltip
                          title={
                            translations &&
                            translations.name + ": " + data[i].name
                          }
                        >
                          <span
                            className="asset - card - val;
"
                          >
                            {data[i].name}
                          </span>
                        </Tooltip>
                      </li>
                      <li>
                        <span
                          data-translationkey="dimensions"
                          className="asset-card-prop"
                        >
                          {translations
                            ? translations.dimensions + ": "
                            : "dimensions: "}
                        </span>
                        <Tooltip
                          title={
                            translations &&
                            translations.dimensions + ": " + data[i].size
                          }
                        >
                          <span className="asset-card-val">{data[i].size}</span>
                        </Tooltip>
                      </li>
                      <li>
                        <span
                          data-translationkey="size"
                          className="asset-card-prop"
                        >
                          {translations ? translations.size + ": " : "size: "}
                        </span>
                        <Tooltip
                          title={
                            translations &&
                            translations.size + ": " + data[i].originalfile.size
                          }
                        >
                          <span className="asset-card-val">
                            {data[i].originalfile.size}
                          </span>
                        </Tooltip>
                      </li>
                      <li>
                        <span
                          data-translationkey="format"
                          className="asset-card-prop"
                        >
                          {translations ? translations.format + ": " : "format: "}
                        </span>

                        <Tooltip
                          title={
                            translations &&
                            translations.format +
                            ": " +
                            data[i].originalfile.format
                          }
                        >
                          <span className="asset-card-val">
                            {data[i].originalfile.format}
                          </span>
                        </Tooltip>
                      </li>
                      <li>
                        <span
                          data-translationkey="date"
                          className="asset-card-prop"
                        >
                          {translations
                            ? translations.modificationDate + ": "
                            : "date: "}
                        </span>

                        <Tooltip
                          title={
                            translations &&
                            translations.modificationDate +
                            ": " +
                            data[i].modificationdate
                          }
                        >
                          <span className="asset-card-val">
                            {data[i].modificationdate}
                          </span>
                        </Tooltip>
                      </li>
                    </ul>
                    {editableView && (
                      <div className="asset-card-footer">
                        {(this.props.admaterialid < 0 ||
                          !this.props.admaterialid) && (
                            <span className="button-set-visual d-none">
                              <Button
                                data-translationkey="setAsVisual"
                                type="secondary"
                                size="small"
                                onClick={() =>
                                  this.setAsVisual(
                                    this.props.matspecid,
                                    data[i].id
                                  )
                                }
                              >
                                {translations
                                  ? translations.setAsVisual
                                  : "Set as visual"}
                              </Button>
                            </span>
                          )}
                        {data[i].actions.DOWNLOAD && (
                          <a
                            href={data[i].originalfile.url}
                            className="asset-card-download"
                            download={data[i].inputfilename}
                          >
                            <Icon type="download" />
                          </a>
                        )}
                        {data[i].actions.DELETE && (
                          <Button
                            type="secondary"
                            onClick={() => this.deleteAsset(data[i].id)}
                          >
                            <Icon type="delete" />
                          </Button>
                        )}
                      </div>
                    )}
                  </Card>
                </Col>
              );
            }
          }
          this.setState({ assetsCards: assetsCards, preloadingMask: false });
        })
        .catch(e => console.error("Cannot load assets", e));
    } else {
      console.error("Assets: Cannot load assets without matspecid");
    }
  };
  /*shouldComponentUpdate(){
			console.log('should')
			return true
		}*/
  componentWillReceiveProps(nextProps, prevProps) {
    //console.log('Assets: will receive props', nextProps);
    if (this.props.editableView !== nextProps.editableView)
      this.setState({ editableView: nextProps.editableView });
    if (this.props.matspecid !== nextProps.matspecid) {
      assetsCards = [];
      !this.isCancelled && this.setState({ matspecid: nextProps.matspecid });
    }
    if (this.props.translations !== nextProps.translations)
      this.setState({ translations: nextProps.translations });
    const that = this;
    if (
      nextProps.matspecid !== this.props.matspecid ||
      nextProps.newAssetNoteId !== this.props.newAssetNoteId ||
      nextProps.newAssetIds !== this.props.newAssetIds
    )
      setTimeout(function () {
        if (nextProps)
          that.loadAssets(nextProps.matspecid, nextProps.newAssetIds);
        //if(nextProps.newAssetNoteId)
        //  that.loadAssets(nextProps.matspecid, nextProps.newAssetIds);
      }, 250);
  }

  render() {
    //console.log('Assets: rendering...', this.state.editableView);
    return (
      <div className="asset-cards-container">
        <Button
          id="refreshAssets"
          onClick={() =>
            this.loadAssets(this.props.matspecid, this.props.newAssetIds)
          }
        >
          Refresh
        </Button>
        <div
          id="preloadingAssetMask"
          data-visible={this.state.preloadingMask}
          className="preloading-mask"
        >
          <Icon type="loading" />
          <span data-translationkey="loading">
            {this.props.translations.loading}
          </span>
        </div>
        <Row gutter={16}>
          {this.state.assetsCards && this.state.assetsCards.length > 0
            ? this.state.assetsCards
            : null}
        </Row>
      </div>
    );
  }

  componentDidMount() {
    //console.log('Assets: mounted', this.state.editableView);
    this.loadAssets(this.props.matspecid, this.props.newAssetIds);
  }

  componentDidUpdate(nextProps) {
    //console.log("componentDidUpdate");
    if (
      this.props.editableView !== nextProps.editableView ||
      this.props.matspecid !== nextProps.matspecid ||
      this.props.newAssetIds !== nextProps.newAssetIds ||
      this.props.translations !== nextProps.translations
    ) {
      //console.log('Assets: updated', nextProps);
      //this.loadAssets(nextProps.matspecid, nextProps.newAssetIds);
    } else {
      //console.log('Assets: NOT updated', this.props);
    }
    const comp = this;
    if (!devMode)
      setTimeout(function () {
        if (
          !comp.props.editableView ||
          /* !comp.props.assetView || */
          comp.props.statusCode === 518
        ) {
          const iframe = document.getElementById("assetTabFrame");
          if (
            iframe &&
            iframe.contentWindow.document.getElementById("description")
          ) {
            iframe.contentWindow.document
              .getElementById("description")
              .setAttribute("disabled", "disabled");
            iframe.height = "";
            iframe.height =
              iframe.contentWindow.document.body.scrollHeight + 50 + "px";
          }
        }
      }, 1500);
  }

  componentWillUnmount() {
    this.isCancelled = true;
  }
}

export default Assets;



// WEBPACK FOOTER //
// ./src/components/Assets.js